import React from 'react'
import Home from "./home"

export const metadata = {
  title: 'Home Page - My Awesome Website',
  description: 'Welcome to the home page of my awesome website',
};

export default function HomePage() {
  return (
    <div>
      <Home/>
    </div>
  );
}
